import { calculateAge, filestackPath, formatDate, ia, kebabToReadable } from '../utility';

import { GAP } from './lib/constants';

const generateHeaderImage = (doc, image) => {
  const headerPhotoData = JSON.parse(image);
  const img = filestackPath(headerPhotoData.jpg);

  const maxWidth = 50;
  const maxHeight = 30;

  //This fixes image to contain the max width and height
  try {
    const { width: imgWidth, height: imgHeight } = doc.getImageProperties(img);

    const widthRatio = maxWidth / imgWidth;
    const heightRatio = maxHeight / imgHeight;
    const scale = Math.min(widthRatio, heightRatio);

    const finalWidth = imgWidth * scale;
    const finalHeight = imgHeight * scale;

    //This centers the image inside the box
    const xPos = GAP + (maxWidth - finalWidth) / 2;
    const yPos = GAP + (maxHeight - finalHeight) / 2;

    //This adds the image to the document
    doc.addImage(img, 'JPEG', xPos, yPos, finalWidth, finalHeight);
  } catch (error) {
    console.error('Error loading image:', error);
  }
};

export const generateHeader = ({ doc, startY = GAP, headerConfigs }) => {
  let finalStartY = startY;

  const { practice, patient } = headerConfigs;

  const pageWidth = doc.internal.pageSize.width;

  if (practice?.header_photo) {
    generateHeaderImage(doc, practice.header_photo);
  }

  if (practice) {
    finalStartY += 30;

    const practiceDetails = [
      practice.displayName || '',
      getAddressDisplay(practice?.address) || '',
      practice.phone || '',
      practice.email || '',
      practice.tax_id || ''
    ];
    doc.setFontSize(10);

    let practiceTextY = 15;
    const practiceTextX = pageWidth - GAP;

    practiceDetails.forEach((text) => {
      const textWidth = doc.getTextWidth(text);
      doc.text(text, practiceTextX - textWidth, practiceTextY);
      practiceTextY += 5;
    });
  }

  if (patient) {
    finalStartY += 30;

    doc.setFillColor(0, 58, 75);
    doc.rect(0, 40, pageWidth, 25, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);

    const patientDetails = `${patient?.dob || ''}${` • ${calculateAge({ dateOfBirth: patient?.dob })} years`}${patient?.gender ? ` • ${kebabToReadable(patient.gender)}` : ''}`;

    if (!!patient?.fullName) {
      doc.text(patient.fullName, GAP, 50);
    }

    doc.setFontSize(10);
    doc.text(patientDetails, GAP, 55);

    if (!!patient?.userAddress) {
      doc.text(getAddressDisplay(patient.userAddress), GAP, 60);
    }

    const dateServiceText = `Date of Service: ${formatDate(patient?.service_date, practice?.timezone)}`;
    const chartIDText = `Chart ID: ${patient?.id}`;

    const dateOfServiceX = pageWidth - GAP;

    if (!!patient.service_date) {
      doc.text(dateServiceText, dateOfServiceX - doc.getTextWidth(dateServiceText), 50);
    }

    if (!!patient?.id) {
      doc.text(chartIDText, dateOfServiceX - doc.getTextWidth(chartIDText), 55);
    }
  }

  return finalStartY + GAP / 2;
};

function getAddressDisplay(address) {
  if (address && typeof address === 'object' && !ia(address)) {
    return address?.fullAddress;
  }

  if (address && typeof address !== 'number') {
    return address;
  }

  return null;
}
